module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Undo_16"],"path":[{"$":{"d":"M16,15S15.42,9.8,6,9.8V13L0,8,6,3V6.2C13.25,6.2,16,9.34,16,15Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Undo_16.svg
// module id = MqhX
// module chunks = 1